// removed by extract-text-webpack-plugin
module.exports = {"primary":"#4275b9","secondary":"#d8d8d8","tradera":"#ffcf3c","success":"#43ba7a","info":"#4275b9","warning":"#ffe58e","danger":"#e66159","light":"#e8edf0","dark":"#2d3742"};


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/style/master.scss
// module id = 6a1fa776
// module chunks = 21